var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-empty',{attrs:{"image":"error","description":"页面不存在"}}),_c('div',{staticClass:"add-big-button"},[_c('van-button',{staticClass:"button",attrs:{"size":"small","round":""},on:{"click":_vm.submit}},[_vm._v("返回主页")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }